export const ReportActionTypes = {
  SET_QUESTION_GRADE: "SET_ASSIGNMENT_QUESTION_GRADE",
};
